<template>
  <div class="payment-method-page">
   
    <form class="payment-form" @submit="onSave">
      <fieldset class="credit-card-info">
        <legend>{{ $t('payment.creditCard.title') }}</legend>
        <div class="card-icons">
          <img
            v-for="(card, idx) in cardList"
            :key="card.type"
            :src="card.icon"
            :alt="card.alt"
            :class="{ selected: bankType === card.type }"
            @click="selectBank(card.type)"
          />
        </div>
        <label>
          {{ $t('payment.creditCard.cardNumber') }}<span class="required">*</span>
          <input type="text" required maxlength="19" :placeholder="$t('payment.creditCard.cardNumber')" v-model="form.cardNumber" />
        </label>
        <div class="row">
          <label>
            {{ $t('payment.creditCard.expirationDate') }}<span class="required">*</span>
            <input type="text" required maxlength="7" placeholder="MM / YY" v-model="form.expiryDate"/>
          </label>
          <label>
            {{ $t('payment.creditCard.cvv') }}<span class="required">*</span>
            <input type="text" required maxlength="4" :placeholder="$t('payment.creditCard.cvv')" v-model="form.cvv"/>
            <span class="cvv-tip">{{ $t('payment.creditCard.cvvTip') }}</span>
          </label>
        </div>
        <div class="row">
          <label>
            {{ $t('payment.creditCard.firstName') }}<span class="required">*</span>
            <input type="text" required :placeholder="$t('payment.creditCard.firstName')" v-model="form.firstName"/>
          </label>
          <label>
            {{ $t('payment.creditCard.lastName') }}<span class="required">*</span>
            <input type="text" required :placeholder="$t('payment.creditCard.lastName')" v-model="form.lastName"/>
          </label>
        </div>
      </fieldset>

      <fieldset class="billing-address">
        <legend>{{ $t('payment.billingAddress.title') }}</legend>
        <p class="tip">{{ $t('payment.billingAddress.tip') }}</p>
        <label>
          {{ $t('payment.billingAddress.addressLine1') }}<span class="required">*</span>
          <input type="text" required :placeholder="$t('payment.billingAddress.addressLine1')" v-model="form.defaultAddress"/>
        </label>
        <label>
          {{ $t('payment.billingAddress.addressLine2') }}
          <input type="text" :placeholder="$t('payment.billingAddress.addressLine2')" v-model="form.spareAddress"/>
        </label>
        <div class="row">
          <label>
            {{ $t('payment.billingAddress.city') }}<span class="required">*</span>
            <input type="text" required :placeholder="$t('payment.billingAddress.city')" v-model="form.city"/>
          </label>
        <div class="province-select-wrap">
  <label>
    {{ $t('payment.billingAddress.province') }}<span class="required">*</span>
    <select required v-model="form.province">
      <option value="">{{ $t('payment.billingAddress.selectProvince') }}</option>
      <option value="ON">{{ $t('payment.ontario') }}</option>
      <option value="QC">{{ $t('payment.quebec') }}</option>
      <option value="BC">{{ $t('payment.britishColumbia') }}</option>
      <option value="AB">{{ $t('payment.alberta') }}</option>
    </select>
  </label>
</div>
        </div>
        <div class="row">
          <label>
            {{ $t('payment.billingAddress.postalCode') }}<span class="required">*</span>
            <input type="text" required :placeholder="$t('payment.billingAddress.postalCode')" v-model="form.postalCode"/>
          </label>
          <label>
            {{ $t('payment.billingAddress.phoneNumber') }}<span class="required">*</span>
            <input type="text" required :placeholder="$t('payment.billingAddress.phoneNumber')" v-model="form.phoneNumber"/>
          </label>
        </div>
        <label class="save-card">
          <input type="checkbox" />
          {{ $t('payment.saveCard') }}
        </label>
      </fieldset>
      <div class="form-actions">
        <button type="button" class="cancel-btn">{{ $t('payment.cancel') }}</button>
        <button type="submit" class="save-btn">{{ $t('payment.save') }}</button>
      </div>
    </form>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import emitter from '@/utils/eventBus'
import { useRouter } from 'vue-router'
import { PayMethodAdd } from '@/api/payMethod'
import { ElLoading,ElMessage } from 'element-plus' 
import { getUserId } from '@/services/userInfo' 


const { t } = useI18n()
const router = useRouter()

const bankType = ref("visa") // 默认选中Visa
const cardList = [
  { type: 'visa', icon: 'https://img.icons8.com/color/48/000000/visa.png', alt: 'Visa', value: 1 },
  { type: 'mastercard', icon: 'https://img.icons8.com/color/48/000000/mastercard.png', alt: 'MasterCard', value: 2 },
  { type: 'amex', icon: 'https://img.icons8.com/color/48/000000/amex.png', alt: 'Amex', value: 3 }
]

// 你的表单数据
const form = ref({
  cardBank: bankType.value,
  cardNumber: '',
  expiryDate: '',
  cvv: '',
  firstName: '',
  lastName: '',
  defaultAddress: '',
  spareAddress: '',
  city: '',
  province: '',
  postalCode: '',
  phoneNumber: ''
})

function selectBank(val) {
  bankType.value = val
  form.value.cardType = val
}

// 保存按钮事件
async function onSave(e) {
  e.preventDefault()
  // 这里可以做校验
  console.log('监听addCard事件')
const params = {
  ...form.value,
  cardHolder: `${form.value.firstName} ${form.value.lastName}`,
  userId: getUserId()
}
delete params.firstName
delete params.lastName
  console.log('触发addCard事件', params)
 
  // 显示加载动画

  const loadingInstance = ElLoading.service({
    lock: true,
    text: "",
    background: 'rgba(255,255,255,0.7)'
  })

  try {
    const res = await PayMethodAdd(params)
    if (res.code === 200) {
      ElMessage.success({
        message: t('payment.addSuccess') ,
        duration: 2000
      })
      router.back()
    } else {
      ElMessage.error({
        message: res.msg || t('payment.addFailed'),
        duration: 2000
      })
    }
  } catch (err) {
    ElMessage.error({
      message: (err && err.message) || t('payment.addFailed') ,
      duration: 2000
    })
  } finally {
    loadingInstance.close()
  }


 
}
</script>

<style scoped>

.payment-method-page {
  width: 100%;
  color: #d94a00;
  padding-bottom: 20px;
}

h2 {
  margin-bottom: 32px;
  font-size: 28px;
  font-weight: 500;
  color: #9b2222;
  padding: 0 32px; /* 保持标题左对齐 */
}

.payment-form {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  
 
}

/* 确保字段集内容左对齐 */
.payment-form fieldset {
  border: none;
  margin: 0 0 32px 0; /* 只保留底部margin */
  padding: 0;
  position: relative;
}

/* 确保图标对齐 */
.card-icons {
  display: flex;
  gap: 12px;
  margin: 0 0 24px 0; /* 只保留底部margin */
  padding: 0;
}

/* 确保输入框左对齐 */
label {
  display: block;
  margin-bottom: 20px;
  padding: 0;
  width: 100%;
}

/* 确保行内元素对齐 */
.row {
  display: flex;
  gap: 24px;
  margin: 0 0 20px 0; /* 只保留底部margin */
  padding: 0;
  width: 100%;
}

/* 保存信用卡复选框对齐 */
.save-card {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 24px 0 0 0; /* 只保留顶部margin */
  padding: 0;
}

/* 按钮容器对齐 */
.form-actions {
  display: flex;
  gap: 16px;
  margin: 32px 0 0 0; /* 只保留顶部margin */
  padding: 0;
}


h2 {
  margin-bottom: 32px;
  font-size: 28px;
  font-weight: 500;
  color: #333;
  padding-left: 32px; /* Add left padding to align with form */
}

.payment-form {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 8px;
  padding: 32px;
}

/* Remove fieldset borders and adjust spacing */
.payment-form fieldset {
  border: none;
  margin-bottom: 32px;
  padding: 0;
  position: relative;
}

/* Adjust legend styling */
.payment-form legend {
  font-size: 20px;
  font-weight: 500;
  color: #333;
  margin-bottom: 24px;
  padding: 0;
  position: static; /* Remove absolute positioning */
}

.card-icons {
  display: flex;
  gap: 12px;
  margin-bottom: 24px;
}

.card-icons img {
  height: 32px;
  width: auto;
  cursor: pointer;
  transition: transform 0.2s, box-shadow 0.2s;
  border-radius: 4px;
  border: 2px solid transparent;
}
.card-icons img.selected {
  transform: scale(1.2);
  border-color: #fb6e01;
  box-shadow: 0 2px 8px rgba(0,103,184,0.10);
  background: #f0f8ff;
}

label {
  display: block;
  margin-bottom: 20px;
  font-size: 14px;
  color: #444;
}

input, select {
  width: 100%;
  
  padding: 8px 12px;
  margin-top: 8px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 15px;
  height: 40px;
  box-sizing: border-box;
   padding-right: 30px;
}



.row {
  display: flex;
  gap: 24px;
  margin-bottom: 20px;
}

.row > label {
  flex: 1;
}

.required {
  color: #d94a00;
  margin-left: 2px;
}

.cvv-tip {
  font-size: 13px;
  color: #666;
  margin-left: 4px;
}

.tip {
  font-size: 14px;
  color: #666;
  margin: -8px 0 24px;
}

.save-card {
  display: flex;
  align-items: center;
  gap: 8px;
  margin: 24px 0 0;
  font-size: 14px;
}

.save-card input[type="checkbox"] {
  width: 18px;
  height: 18px;
  margin: 0;
}

.form-actions {
  display: flex;
  gap: 16px;
  margin-top: 32px;
}

.cancel-btn, .save-btn {
  padding: 10px 32px;
  font-size: 15px;
  border-radius: 4px;
  cursor: pointer;
  min-width: 100px;
}

.cancel-btn {
  background: #f5f5f5;
  border: 1px solid #ddd;
  color: #333;
}

.save-btn {
  background: #fb6e01;  /* 改用蓝色主题 */
  border: none;
  color: #fff;
}

.save-btn:hover {
  background: #005399;
}

select {
  /* 其他样式... */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  background: #fff;
  background-image: url("data:image/svg+xml;utf8,<svg fill='gray' height='16' viewBox='0 0 24 24' width='16' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 20px center; /* 调整箭头距离右边的位置 */
  background-size: 24px 24px;
  padding-right: 40px; /* 给箭头留空间 */
}

.province-select-wrap select {
  width: 100%;
  padding: 8px 40px 8px 12px; /* 右侧多留空间给箭头 */
  font-size: 16px;
  border: 1px solid #ccc;
  border-radius: 4px;
  height: 44px;
  appearance: none;
  background: #fff;
  background-image: url("data:image/svg+xml;utf8,<svg fill='gray' height='18' viewBox='0 0 24 24' width='18' xmlns='http://www.w3.org/2000/svg'><path d='M7 10l5 5 5-5z'/></svg>");
  background-repeat: no-repeat;
  background-position: right 16px center;
  background-size: 22px 22px;
  box-sizing: border-box;
}

@media (max-width: 768px) {
  .province-select-wrap select {
    font-size: 18px;
    height: 48px;
    background-position: right 12px center;
    padding-right: 36px;
  }
  .province-select-wrap label {
    font-size: 17px;
  }
}
</style>
